import React, { CSSProperties } from "react";
import styled from "styled-components";
import { makeMediaQuery } from "./utils";
import { BREAKPOINTS_MAX_WIDTH } from "./constants";

const LayoutStyled = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  max-width: 100%;

  ${makeMediaQuery("xs", "min", { maxWidth: `${BREAKPOINTS_MAX_WIDTH.xs}px` })}
  ${makeMediaQuery("sm", "min", { maxWidth: `${BREAKPOINTS_MAX_WIDTH.sm}px` })}
  ${makeMediaQuery("md", "min", { maxWidth: `${BREAKPOINTS_MAX_WIDTH.md}px` })}
  ${makeMediaQuery("lg", "min", { maxWidth: `${BREAKPOINTS_MAX_WIDTH.lg}px` })}
  ${makeMediaQuery("xl", "min", { maxWidth: `${BREAKPOINTS_MAX_WIDTH.xl}px` })}
  ${makeMediaQuery("xxl", "min", { maxWidth: `${BREAKPOINTS_MAX_WIDTH.xxl}px` })}
`;

export type CtPublicContainerProps = {
  className?: string;
  children: React.ReactNode;
  style?: CSSProperties;
};

function CtPublicContainer({ children, style, className }: CtPublicContainerProps) {
  return (
    <LayoutStyled style={style} className={className}>
      {children}
    </LayoutStyled>
  );
}

export default CtPublicContainer;
